module.exports = __webpack_public_path__ + "img/6.5aa37760.svg";